export const useHtmlToString = str => {
  return str?.length >= 1 && str?.replace(/<[^>]+>/g, "")
}
